import { Typography, Button } from "@plum-xoxo/admin-dsm";
import React, { Component } from "react";
import Workbook from "react-excel-workbook";

const sampleData = [
  {
    product_id: 123,
    receiver_name:'John',
    name: "PRODUCT NAME1",
    Denomination: 100,
    quantity: 5,
    receiver_email: "test@test.com",
    receiver_mobile_code: "+91",
    receiver_mobile: "9111111111",
    po_number: "12345",
    user_message: "A big thank you from us",
  },
];

const instructions = [
  {
    text: "Instructions",
  },
  {
    text: "1. Mandatory Attributes are highlighted in Yellow.",
  },
  {
    text: "2. Do not add extra columns.",
  },
  {
    text: "3. Do not change the headers of the column.",
  },
  {
    text: "4. India Products and International Products contains denominations for all products along with Product ID. ",
  },
  {
    text: " ",
  },
  {
    text: "How to use Sample Sheet?",
  },
  {
    text: "1. Enter the Product Name, Product ID and the Denomination from the India/ International Products worksheet",
  },
  {
    text: "2. Please enter the required quantity selected for sending rewards",
  },
  {
    text: "3. Enter the receiver's email address, ISO Code (Country Code) and mobile number",
  },
  {
    text: "4.  PO Number and TAG ( This is for your internal reference and will not be visible to the receiver)",
  },
  {
    text: "5. Enter the personal message",
  },
  {
    text: " ",
  },
  {
    text: "Note: The denominations set for the specific products are to be added. A change in denomination from the ones mentioned in the sheet will not be accepted.",
  },
];

class DownloadSampleProduct extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { voucherProducts } = this.props;

    // console.log("total voucherList===" , voucherProducts);

    let indianProduct = voucherProducts.filter(
      (item) => item.country_name === "India"
    );
    let internationProduct = voucherProducts.filter(
      (item) => item.country_name !== "India"
    );

    //  console.log("indianProduct===" , indianProduct);
    //  console.log("internationProduct" , internationProduct);

    return (
      <>
        <Workbook
          filename="plum-pro-bulk-upload.xlsx"
          element={
            <span id="download-file-plum-pro"></span>
          }
        >
          <Workbook.Sheet data={sampleData} name="Sample Sheet">
            <Workbook.Column label="Name" value="receiver_name" />
            <Workbook.Column label="ProductId" value="product_id" />
            <Workbook.Column label="Product Name" value="name" />
            <Workbook.Column label="denomination" value="Denomination" />
            <Workbook.Column label="Quantity" value="quantity" />
            <Workbook.Column label="Receiver's Email" value="receiver_email" />
            <Workbook.Column label="Iso Code" value="receiver_mobile_code" />
            <Workbook.Column
              label="Receiver's Mobile"
              value="receiver_mobile"
            />
            <Workbook.Column label="PO number" value="po_number" />
            <Workbook.Column label="Tag" value="tag" />
            <Workbook.Column
              label="Personal Message in Email"
              value="user_message"
            />
          </Workbook.Sheet>
          <Workbook.Sheet data={instructions} name="Instructions">
            <Workbook.Column label="" value="text" />
          </Workbook.Sheet>
          <Workbook.Sheet data={indianProduct} name="India Products">
            <Workbook.Column label="ProductId" value="product_id" />
            <Workbook.Column label="Product Name" value="name" />
            <Workbook.Column label="Denomination" value="prices" />
          </Workbook.Sheet>
          <Workbook.Sheet
            data={internationProduct}
            name="International Products"
          >
            <Workbook.Column label="ProductId" value="product_id" />
            <Workbook.Column label="Product Name" value="name" />
            <Workbook.Column label="Denomination" value="prices" />
          </Workbook.Sheet>
        </Workbook>
      </>
    );
  }
}

export default DownloadSampleProduct;
